import React from 'react';
import './ServicesPage.css';
import {useTranslation} from "react-i18next";
import VideoGallery from "../Gallery/VideoGallery";

function VideoSectionPage() {
    const { t } = useTranslation();

    return (
        <div className="services-page">
            <h1>{t("Video Section")}</h1>
            <div className="services-info-container">
                <VideoGallery />
            </div>

        </div>
    );
}

export default VideoSectionPage;
